import { render, staticRenderFns } from "./ViewEditClinicSettings.vue?vue&type=template&id=2b0df556&scoped=true&"
import script from "./ViewEditClinicSettings.vue?vue&type=script&lang=js&"
export * from "./ViewEditClinicSettings.vue?vue&type=script&lang=js&"
import style0 from "./ViewEditClinicSettings.vue?vue&type=style&index=0&id=2b0df556&prod&lang=scss&"
import style1 from "./ViewEditClinicSettings.vue?vue&type=style&index=1&id=2b0df556&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0df556",
  null
  
)

export default component.exports